/* Kleine eigene Komponenten nach den Mockups. Werte aus @obsn/shared/tokens.css. Ziele mindestens 44 px. */

.knopf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: var(--target);
  padding: 0 18px;
  border-radius: var(--radius-pill);
  /* Weiß mit Rand (Mockup Flächen): --surface läge fast in der Farbe der Seitenfläche */
  border: 2px solid var(--rand-karte);
  background: var(--flaeche-karte);
  color: var(--text);
  font: 600 14px var(--font);
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}
.knopf:hover:not(:disabled) {
  border-color: var(--text);
}
.knopf:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.primaer {
  background: var(--black);
  border-color: var(--black);
  color: var(--white);
  padding-left: 6px;
}
.primaer:hover {
  border-color: var(--black);
}
.primaer::before {
  content: "";
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--accent);
  flex: none;
}
.primaerOhnePunkt {
  padding-left: 18px;
}
.primaerOhnePunkt::before {
  display: none;
}
.gefahr {
  background: var(--white);
  color: var(--danger);
  border-color: var(--danger);
}
.leise {
  background: transparent;
  border-color: transparent;
}
.klein {
  min-height: var(--target);
  padding: 0 14px;
  font-size: 13px;
}

/* Flächen (BAUPLAN-FLAECHEN.md, ADR-020): Karte, klickbare Karte (KarteLink) und Innenfläche. Seiten setzen keine eigenen
   Schatten, Ränder oder Flächenfarben, sondern nutzen diese Klassen oder die Komponenten Karte und KarteLink. */
.karte {
  background: var(--flaeche-karte);
  border: 1px solid var(--rand-karte);
  border-radius: var(--radius-karte);
  box-shadow: var(--schatten-1);
  padding: 22px;
  min-width: 0;
}
/* Ganze Karte ist ein Link: beim Zeigen --schatten-2 und 2 px höher, beim Drücken zurück */
.karteLink {
  display: block;
  color: inherit;
  text-decoration: none;
  transition:
    box-shadow 0.2s,
    transform 0.15s;
}
.karteLink:hover {
  box-shadow: var(--schatten-2);
  transform: translateY(-2px);
}
.karteLink:active {
  transform: none;
}
.karteLink:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: 3px;
}
/* „Öffnen →“ unten in der klickbaren Karte, nur Text */
.karteWeiter {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  font-weight: 600;
  color: var(--accent-ink);
}
.karteFuss {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid var(--rand-karte);
}
.karteFuss .karteWeiter {
  margin-top: 0;
}
/* Innenfläche in einer Karte: Kennzahlen, Schritte, Kästen. Ohne Rand und Schatten. */
.innen {
  background: var(--flaeche-innen);
  border-radius: var(--radius-innen);
  padding: 12px 14px;
  min-width: 0;
}
@media (max-width: 760px) {
  .karte {
    padding: 16px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .karteLink,
  .karteLink:hover {
    transition: none;
    transform: none;
  }
}
.karte > h2 {
  margin: 0 0 4px;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: var(--text);
}
.unterzeile {
  margin: 0 0 var(--sp-2);
  font-size: 13px;
  color: var(--muted);
}

.feld {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.label {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--muted);
}
/* Felder rund und weiß (BAUPLAN-FEINSCHLIFF.md, Abschnitt 3.5): Rand 1,5 px, 46 px hoch, select mit eigenem Pfeil, Fokus 3 px.
   Mehrzeilige Felder mit --radius-innen. */
.eingabe {
  width: 100%;
  min-height: 46px;
  border-radius: var(--radius-pill);
  border: 1.5px solid var(--rand-karte);
  background-color: var(--white);
  padding: 0 18px;
  font: 500 15px var(--font);
  color: var(--text);
}
select.eingabe {
  appearance: none;
  padding-right: 44px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%231E1E1E' stroke-opacity='.55' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 18px center;
  cursor: pointer;
}
select.eingabe:disabled {
  cursor: not-allowed;
}
textarea.eingabe {
  border-radius: var(--radius-innen);
  padding: 12px 16px;
  line-height: 1.45;
}
.eingabe:hover:not(:disabled):not(:focus) {
  border-color: var(--dashed);
}
.eingabe:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: 1px;
  border-color: var(--black);
}
.eingabe[aria-invalid="true"] {
  border-color: var(--danger);
}
.hilfe {
  font-size: 13px;
  color: var(--muted);
}
.fehlertext {
  font-size: 13px;
  font-weight: 600;
  color: var(--danger);
}

/* Hilfe „?“ neben einem Seitentitel (BAUPLAN-SPRINT-KOPF.md, Abschnitt 1): leise, 44 px Trefferfläche, Text in Schwebend */
.hilfeKnopf {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: var(--target);
  height: var(--target);
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}
.hilfeKnopf:hover,
.hilfeKnopf[aria-expanded="true"] {
  background: var(--surface);
  color: var(--text);
}
.hilfeKnopf:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: 2px;
}
.hilfeText {
  padding: var(--a4);
  font-size: var(--fs-text);
  line-height: 1.5;
  color: var(--text);
}
.hilfeText:focus {
  outline: none;
}
.hilfeText p {
  margin: 0;
}

.schalterZeile {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: var(--target);
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  cursor: pointer;
}
.schalter {
  appearance: none;
  width: 44px;
  height: 26px;
  border-radius: 13px;
  background: var(--line);
  position: relative;
  margin: 0;
  cursor: pointer;
  flex: none;
}
.schalter::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--white);
  transition: left 0.2s;
}
.schalter:checked {
  background: var(--black);
}
.schalter:checked::after {
  left: 21px;
}
.schalter:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.segment {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 4px;
  padding: 4px;
  border: 0;
  margin: 0;
  border-radius: 12px;
  background: var(--surface);
  /* Rand als Schattenlinie, damit die Legende des fieldset ihn nicht unterbricht. Ohne Rand läge --surface fast in der Seitenfläche. */
  box-shadow: inset 0 0 0 1px var(--rand-karte);
}
.segment label {
  position: relative;
}
.segment input {
  position: absolute;
  opacity: 0;
  inset: 0;
  margin: 0;
}
.segment span {
  display: inline-flex;
  align-items: center;
  min-height: var(--target);
  padding: 0 14px;
  border-radius: 9px;
  font: 600 13px var(--font);
  color: var(--muted);
  cursor: pointer;
}
.segment input:checked + span {
  background: var(--white);
  color: var(--text);
  box-shadow: var(--schatten-1);
}
.segment input:focus-visible + span {
  outline: 3px solid var(--focus);
  outline-offset: 1px;
}
.segment input:disabled + span {
  cursor: not-allowed;
  opacity: 0.6;
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e4e2de;
  color: var(--text);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex: none;
  overflow: hidden;
  object-fit: cover;
}

.marke {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  background: var(--surface);
  color: var(--text);
  white-space: nowrap;
}
.markeDunkel {
  background: var(--black);
  color: var(--white);
}
.markeOk {
  background: #e7f5ec;
  color: var(--ok);
}
.markeWarten {
  background: #fff6d6;
  color: #6b5300;
}
.markeAus {
  background: #fbe9e7;
  color: var(--danger);
}

.leer {
  padding: var(--sp-3) 0;
  color: var(--muted);
  font-size: 15px;
}
.leer strong {
  display: block;
  color: var(--text);
  font-size: 16px;
  margin-bottom: 4px;
}

.meldung {
  padding: 12px 14px;
  border: 1px solid var(--rand-karte);
  border-radius: 12px;
  background: var(--surface);
  font-size: 14px;
  color: var(--text);
}
.meldungFehler {
  border-color: transparent;
  background: #fbe9e7;
  color: var(--danger);
  font-weight: 600;
}

.dialog {
  border: 0;
  border-radius: var(--radius-card);
  padding: 24px;
  width: min(460px, calc(100vw - 32px));
  box-shadow: var(--schatten-3);
  color: var(--text);
}
.dialog::backdrop {
  background: rgba(9, 9, 9, 0.45);
}
.dialog h2 {
  margin: 0 0 8px;
  font-size: 20px;
}
.dialog p {
  margin: 0 0 var(--sp-3);
}
.dialogKnoepfe {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

/* Karte „Erste Schritte“ auf Meine Woche */
.ersteSchritte h2 {
  margin: 0;
}
.ersteKopf {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}
.ersteKopf .unterzeile {
  margin: 2px 0 0;
}
.ersteListe {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}
/* Schritte als Innenflächen (ui.innen), erledigte grün mit dem Wort „Erledigt“ */
.ersterSchritt {
  display: flex;
  gap: 10px;
  padding: 14px;
}
.ersterSchritt[data-fertig="true"] {
  background: var(--ok-bg);
}
.ersterSchritt b {
  display: block;
  font-weight: 600;
}
.ersterSchritt p {
  margin: 4px 0 10px;
  font-size: 14px;
  color: var(--body-color);
}
.ersteZahl {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 26px;
  height: 26px;
  border: 2px solid var(--text);
  border-radius: 50%;
  font-size: 13px;
  font-weight: 600;
}
[data-fertig="true"] .ersteZahl {
  border-color: var(--ok);
  background: var(--ok);
  color: var(--white);
}
.ersterSchritt .ersteErledigt {
  margin: 0;
  font-weight: 600;
  color: #1f5f38;
}

/* Haken vor einer Aufgabe: 44 px Ziel, 24 px Kreis. Rand #8A8378 hat 3,7:1 auf Weiß. */
.haken {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: var(--target);
  height: var(--target);
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: none;
  cursor: pointer;
}
.haken:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: -2px;
}
.hakenKreis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 2px solid #8a8378;
  border-radius: 50%;
  background: var(--white);
  color: transparent;
  transition:
    background-color 0.12s,
    border-color 0.12s;
}
.hakenKreis svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.haken:hover:not([aria-disabled="true"]) .hakenKreis {
  border-color: var(--ok);
  color: var(--ok);
}
.haken[aria-pressed="true"] .hakenKreis {
  border-color: var(--ok);
  background: var(--ok);
  color: var(--white);
}
.haken[aria-disabled="true"] {
  cursor: not-allowed;
}
.haken[aria-disabled="true"] .hakenKreis {
  border-style: dashed;
}
.haken[aria-disabled="true"][aria-pressed="true"] .hakenKreis {
  border-style: solid;
  opacity: 0.7;
}
@media (prefers-reduced-motion: reduce) {
  .hakenKreis {
    transition: none;
  }
}

.hinweise {
  position: fixed;
  left: 50%;
  bottom: 88px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 50;
  width: min(520px, calc(100vw - 32px));
}
.hinweis {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 10px 10px 16px;
  border-radius: 14px;
  background: var(--black);
  color: var(--white);
  font-size: 14px;
  font-weight: 600;
  box-shadow: var(--schatten-3);
}
.hinweis span {
  flex: 1;
}
.hinweis button {
  min-height: var(--target);
  padding: 0 14px;
  border-radius: 10px;
  border: 0;
  background: rgba(255, 255, 255, 0.12);
  color: var(--white);
  font: 600 13px var(--font);
  cursor: pointer;
}
.hinweisFehler {
  background: var(--danger);
}

.nurLeser {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

/* Wortmarke: Stern als Marker unten rechts an der Grundlinie statt hochgestellt (Brand Board Okt. 2026, wie .ast auf obsn.de) */
.wortmarke {
  white-space: nowrap;
}
.wortmarkeStern {
  color: var(--accent);
  font-size: 0.6em;
  position: relative;
  top: 0.36em;
  margin-left: -0.01em;
}

/* Reiter (BAUPLAN-PAKETE.md, Abschnitt 5.4): Linie in Orange als Marker, aktiv zusätzlich fett */
.reiter {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--line);
  overflow-x: auto;
  scrollbar-width: thin;
}
.reiter > a,
.reiter > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: none;
  min-height: var(--target);
  padding: 0 14px;
  margin-bottom: -1px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: var(--text);
  font: 500 14px var(--font);
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}
.reiter > a:hover,
.reiter > button:hover {
  border-bottom-color: var(--line);
}
.reiter > [aria-selected="true"],
.reiter > [aria-selected="true"]:hover {
  border-bottom-color: var(--accent);
  font-weight: 600;
}
.reiter > a:focus-visible,
.reiter > button:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: -3px;
}
.reiterZahl {
  font-size: var(--fs-min);
  font-weight: 500;
  color: var(--muted);
}

/* Ladeanzeige */
.laedt {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}
.laedtKreis {
  width: 14px;
  height: 14px;
  border: 2px solid var(--line);
  border-top-color: var(--text);
  border-radius: 50%;
  animation: laedtDreht 0.9s linear infinite;
}
@keyframes laedtDreht {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .laedtKreis {
    animation: none;
  }
}

/* Glocke (KOPFZEILE.md, Abschnitt 3.3): Zahl als Marke, orange Fläche mit schwarzer Schrift. Der Rand trennt sie vom Grund. */
.glocke {
  position: relative;
  display: inline-flex;
}
.glockeZahl {
  position: absolute;
  top: -7px;
  left: calc(100% - 9px);
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  background: var(--accent);
  color: var(--black);
  font: 700 13px/20px var(--font);
  text-align: center;
  box-shadow: 0 0 0 2px var(--glocke-rand, var(--white));
}

/* Listenraster (BAUPLAN-FEINSCHLIFF.md, Abschnitt 3.7, ADR-021). Eine Liste ist eine Karte ohne Innenabstand (karteListe) mit Zeilen
   in festen Spalten: Titel | Pille | Betrag oder Aktion. So stehen Pillen und Beträge aller Zeilen untereinander. Die Breiten setzt
   die Liste über CSS-Variablen (--spalte-pille, --spalte-betrag, --spalte-aktion). Ist die Liste schmal (Handy), steht der Titel
   oben, Betrag oder Aktion rechts daneben und die Pille darunter links. */
.karteListe {
  padding: 0;
  overflow: hidden;
}
.zeilen {
  --spalte-pille: 136px;
  --spalte-betrag: 120px;
  --spalte-aktion: 148px;
  container-type: inline-size;
  margin: 0;
  padding: 0;
  list-style: none;
}
.zeile {
  display: grid;
  grid-template-columns: minmax(0, 1fr) var(--spalte-pille) var(--spalte-betrag);
  align-items: center;
  gap: var(--a4);
  min-height: 64px;
  padding: var(--a3) var(--a5);
  border-bottom: 1px solid var(--rand-karte);
}
.zeile:last-child {
  border-bottom: 0;
}
.zeileZwei {
  grid-template-columns: minmax(0, 1fr) var(--spalte-pille);
}
.zeileAktion {
  grid-template-columns: minmax(0, 1fr) var(--spalte-pille) var(--spalte-aktion);
}
/* Titel 15 px 600, darf umbrechen, nie abgeschnitten. Meta 13 px 400 grau, 2 px darunter. */
.zeileTitel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
  font-size: var(--fs-zeile);
  font-weight: 600;
  line-height: 1.35;
  color: var(--text);
  overflow-wrap: anywhere;
}
.zeileMeta {
  font-size: var(--fs-ober);
  font-weight: 400;
  color: var(--muted);
}
.zeileRechts {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  justify-self: end;
  min-width: 0;
  text-align: right;
}
/* Zwischenzeile, zum Beispiel eine Kategorie: 13 px 500 grau, Summe rechts */
.zwischen {
  display: flex;
  justify-content: space-between;
  gap: var(--a3);
  padding: var(--a5) var(--a5) var(--a1);
  font-size: var(--fs-ober);
  font-weight: 500;
  color: var(--muted);
}
.zwischen > :last-child {
  font-variant-numeric: tabular-nums;
}
@container (max-width: 560px) {
  .zeile,
  .zeileZwei,
  .zeileAktion {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "t r"
      "p p";
    row-gap: var(--a2);
    padding: var(--a3) var(--a4);
  }
  .zeileZwei {
    grid-template-areas:
      "t t"
      "p p";
  }
  .zeileAktion {
    grid-template-areas:
      "t t"
      "p r";
  }
  .zeile > :nth-child(1) {
    grid-area: t;
  }
  .zeile > :nth-child(2) {
    grid-area: p;
    justify-self: start;
  }
  .zeile > :nth-child(3) {
    grid-area: r;
  }
  .zwischen {
    padding-left: var(--a4);
    padding-right: var(--a4);
  }
}
